import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content class="mat-typography">
      <p [innerHTML]="data.content"></p>
    </div>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" [mat-dialog-close]="true" *transloco="let t">{{ t('common.close') }}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['info-dialog.component.scss']
})
export class InfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, content: string }) {}
}
